import { render, staticRenderFns } from "./component-ff839c09.vue?vue&type=template&id=8c5c57d2&scoped=true&"
import script from "./component-ff839c09.vue?vue&type=script&lang=js&"
export * from "./component-ff839c09.vue?vue&type=script&lang=js&"
import style0 from "./component-ff839c09.vue?vue&type=style&index=0&id=8c5c57d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c57d2",
  null
  
)

export default component.exports